<template>
    <div class="app-container">
        <el-form :rules="rules" ref="form" :model="form" label-width="100px" class="event-form">

            <!-- 选择目录 -->
            <el-row>
                <el-col>
                    <el-form-item label="选择目录" prop='parent_id'>
                        <el-cascader
                            clearable
                            ref="getDefaultValue"
                            v-model="form.parent_id"
                            :props="propsData"
                            :show-all-levels='false'>
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 应用名称 -->
            <el-row>
                <el-col>
                    <el-form-item label="应用名称" prop="name">
                        <el-input v-model="form.name" placeholder="请填写应用名称"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- Git 地址 -->
            <el-row>
                <el-col>
                    <el-form-item label="Git 地址" prop="git_path">
                        <el-select
                            v-if='type === "add"'
                            v-model="form.git_path"
                            :remote-method="remoteMethodGit"
                            :loading="loading"
                            filterable
                            remote
                            clearable
                            allow-create
                            placeholder="请填写Git地址"
                            style='width: 100%;'>
                            <el-option
                                v-for="item in listAll.Git_list"
                                :key="item"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                        <span v-else>{{form.git_path}}</span>
                        <!-- <a v-else target="bank" :href="form.git_path">{{form.git_path}}</a> -->

                    </el-form-item>
                </el-col>
            </el-row>

            <!--应用图标-->
            <!--<el-row>-->
            <!--<el-col>-->
            <!--<el-form-item label="应用图标">-->
            <!--<img :src="searchRequery.url" alt="" style='width: 20px;height: 20px;marginRight: 10px;'>-->
            <!--<el-select v-model="form.img_url" placeholder="请选择应用图标" clearable @change='defImgChang'>-->
            <!--<el-option v-for="item in listAll.img_list" :key="item.url" :label="item.title" :value="item.url"/>-->
            <!--</el-select>-->
            <!--</el-form-item>-->
            <!--</el-col>-->
            <!--</el-row>-->

            <!-- 图标上传 -->
            <el-row>
                <el-col :span='24'>
                    <el-form-item label="图标上传">
                        <!--<router-link to='/unLoad'>-->
                        <!--<el-button type='success'>上传文件</el-button>-->
                        <!--</router-link>-->
                        <!--<img v-if='form.img_url' :src="form.img_url" alt="">-->
                        <img v-if="form.img_url" :src="form.img_url" alt="">
                        <router-link :to="{ path: '/unLoad',
                                            query: {
                                                type: 'app',
                                                id: type === 'edit' ? appnodeId : '',
                                                callback: getImage
                                            }
                                        }">
                            <el-button type="success">选择头像</el-button>
                        </router-link>
                        <!--<a href="javascript:;" class="file">选择图标-->
                        <!--<input class="input_file" type="file" @change="changeFn">-->
                        <!--</a>-->
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 应用类型 -->
            <el-row>
                <el-col>
                    <el-form-item label="应用类型" prop='apptype'>
                        <el-select v-if='type==="add"' v-model="form.apptype" placeholder="请选择应用类型" clearable>
                            <el-option v-for="item in type_list" :key="item.id" :label="item.cname" :value="item.id"/>
                        </el-select>
                        <span v-else>{{tableVal(form.apptype,type_list)}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 调用的应用 -->
            <el-row>
                <el-col>
                    <el-form-item label="调用的应用"  >
                        <el-select
                            v-model="form.invokedApp"
                            :remote-method="(query) => remoteMethodApp(query)"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change="showApp"
                        ><el-option
                            v-for="item in listAll.app_list"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 环境 -->
            <el-row>
                <el-col>
                    <el-form-item label="环境" prop='env'>
                        <el-checkbox-group v-model="form.env" @change='changeEnv'>
                            <el-checkbox v-for="item in env" :key='item.id' :label="item.default">{{item.cname}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 部署信息 -->
            <el-row>
                <el-col>
                    <el-form-item label="部署信息">
                        <el-button :disabled="form.env.length? false : true" type="primary" @click="examineParams">查看全部参数配置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 级别 -->
            <el-row>
                <el-col>

                    <el-form-item label="级别">
                        <el-select v-model="form.rank" placeholder="请选择" clearable>
                            <el-option v-for="item in rank" :key="item.defalut" :label="item.cname" :value="item.defalut"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 负责人 -->
            <el-row>
                <el-col>
                    <el-form-item label="负责人" ref='superviser'>
                        <el-select
                            v-model="form.superviser"
                            :remote-method="(query) => remoteMethodUser(query, 'superviser')"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change='changeUser("superviser")'>
                            <el-option
                                v-for="item in listAll.superviser"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 项目经理 -->
            <el-row>
                <el-col>
                    <el-form-item label="项目经理" >
                        <el-select
                            v-model="form.projectusers"
                            :remote-method="(query) => remoteMethodUser(query, 'projectusers')"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change='changeUser("projectusers")'>
                            <el-option
                                v-for="item in listAll.projectusers"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 产品经理 -->
            <el-row>
                <el-col>
                    <el-form-item label="产品经理" >
                        <el-select
                            v-model="form.pmuser"
                            :remote-method="(query) => remoteMethodUser(query, 'pmuser')"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change='changeUser("pmuser")'>
                            <el-option v-for="item in listAll.pmuser" :key="item.label" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 开发人员 -->
            <el-row>
                <el-col>
                    <el-form-item label="开发人员" >
                        <el-select
                            v-model="form.devuser"
                            :remote-method="(query) => remoteMethodUser(query, 'devuser')"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            placeholder="请输入名称进行搜索"
                            @change='changeUser("devuser")'>
                            <el-option v-for="item in listAll.devuser" :key="item.label" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 测试人员 -->
            <el-row>
                <el-col>
                    <el-form-item label="测试人员" >
                        <el-select @change='changeUser("qauser")' v-model="form.qauser" :remote-method="(query) => remoteMethodUser(query, 'qauser')" :loading="loading" multiple filterable remote placeholder="请输入名称进行搜索">
                            <el-option v-for="item in listAll.qauser" :key="item.label" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 运维人员 -->
            <el-row>
                <el-col>
                    <el-form-item label="运维人员" >
                        <el-select @change='changeUser("maintainusers")' v-model="form.maintainusers" :remote-method="(query) => remoteMethodUser(query, 'maintainusers')" :loading="loading" multiple filterable remote placeholder="请输入名称进行搜索">
                            <el-option v-for="item in listAll.maintainusers" :key="item.label" :label="item.label" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 邮件组 -->
            <el-row>
                <el-col>
                    <el-form-item label="邮件组" prop='mails'>
                        <el-tag
                            :key="tag"
                            v-for="tag in form.mails"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="inputVisible"
                            v-model="inputValue"
                            ref="saveTagInput"
                            @keyup.enter.native="handleInputConfirm"
                            @blur="handleInputConfirm">
                        </el-input>
                        <img class='mailBtn' src="../../../assets/mails.png"  @click="showInput">
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 备注 -->
            <el-row>
                <el-col>
                    <el-form-item label="备注">
                        <el-input v-model="form.comment" type='textarea'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">保存</el-button>
                        <el-button type='info' @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>

    import services from '../cicd.services'
    import { getRules } from '../cicd.rules'

    const rules = getRules()

    export default {

        props: {
            type: {
                type:String,
                default:"add"
            },
            appnodeId: Number,
            callback: Function,
            count: {
                type: Object,
                default: {}
            },
            parentType: String
        },

        data() {
            return {
                listAll: {
                    user_list: [],
                    img_list: [],
                    app_list:[],
                    superviser: [],
                    projectusers: [],
                    pmuser: [],
                    devuser: [],
                    qauser: [],
                    maintainusers: [],
                },
                loading: false,
                searchRequery: {
                },
                form: {
                    parent_id: '',
                    name: '',
                    git_path: '',
                    img_url: '',
                    apptype: 2,
                    env: [],
                    rank: '',
                    superviser: [],
                    invokedApp:[],
                    projectusers: [],
                    pmuser: [],
                    devuser: [],
                    qauser: [],
                    maintainusers: [],
                    mails: [],
                    comment: '',
                    server: [],
                    params: [],
                },
                rules: rules,
                propsData: {
                    lazy: true,
                    leaf: 'leaf',
                    checkStrictly: true,
                    lazyLoad: (node, resolve) => this.lazyLoad (node, resolve)
                },
                userTagList: [],
                userList: {},
                inputVisible: false,
                inputValue: '',
                paramsTag: false,
                isDeployed:false,//选择完环境后是否点击过部署按钮
                oldEnv:[],
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            type_list() {
                return this.dictionary.app_type
            },
            env() {
                return this.dictionary.env
            },
            rank() { // 级别
                return this.dictionary.rank[0].default
            },
            useParams() {
                return this.$store.state.useParams
            },
        },

        created() {

            this.getAppList()
            if(this.type == 'edit'){
                this.$modal.title = "编辑应用";
                this.getDetail()
            }else {
                this.$store.commit('setUserParamsServer')
            }

            this.loading = false
        },

        mounted() {
            // console.log(this.type);
            this.requestDefault()

            // if (this.type === 'add') {
            //     this.form.parent_id = this.count.id
            //     this.count.name && (this.$refs.getDefaultValue.$el.children[0].children[0].value = this.count.name)
            // }
        },

        methods: {
            getAppList(){
                let params={
                    pageIndex:1,
                    pageSize:10000,
                }
                services.appList(params).then(res=>{
                    // console.log('hhh');
                    this.listAll.app_list=res.app_list
                })
            },
            showApp(){
                // console.log(this.form.invokedApp);
            },
            // 获取图片
            getImage(val) {
                this.form.img_url = val;
            },
            // 更改环境
            changeEnv() {
                this.paramsTag = true
                // console.log(this.form.env);

                this.isDeployed=false
                // console.log(this.oldEnv);
                let arr1=this.oldEnv.sort().toString()
                let arr2=this.form.env.sort().toString()
                if(arr1==arr2){
                    console.log(true);
                    this.isDeployed=true
                }

            },

            // 查看及编辑参数
            examineParams() {
                let useParam = this.type_list.filter(item => this.form.apptype === item.id)[0]
                let envArr = []
                useParam.env.forEach(item => {
                    this.form.env.forEach(i => {
                        if (item.envId === i) {
                            envArr.push(item)
                        }
                    })
                })
                // if (this.type === 'edit') {
                let envList = envArr.concat(this.form.params)
                let arr = []
                envList.forEach(item => {
                    this.form.env.forEach(i => {
                        if (item.envId === i) {
                            arr.push(item)
                        }
                    })
                })
                useParam = {
                    ...useParam,
                    env: arr,
                    server: this.form.server
                }
                useParam.env = this.distinct(useParam.env)
                // } else {
                //     useParam = {
                //         ...useParam,
                //         env: envArr,
                //         server: this.useParams.server || []
                //     }
                // }
                this.$store.commit('setDefuseParams', useParam)
                this.$store.commit('setUseParams', useParam)
                this.isDeployed=true
                this.$router.push({
                    path: '/paramsMessage',
                    query: {
                        parentType: this.parentType
                    }
                })
            },

            // 去重
            distinct(array){
                let temp = []; //一个新的临时数组
                for(let i = 0; i < array.length; i++){
                    for(let j = i + 1; j < array.length; j++) {
                        if (array[i].envId == array[j].envId) {
                            i++
                            j = i
                        }
                    }
                    temp.push(array[i])
                }
                return temp;
            },

            // 上传文件
            changeFn(e){
                let files = e.target.files || e.dataTransfer.files
                let params = {
                    file_name : files[0]
                };
                services.upload(params)
                    .then(res => this.form.img_url = res.download_url)
                    .catch(err => this.$message.error(err.message))
                    .finally(() => this.$message.success("导入成功"))
            },

            // 默认图片被改变时
            defImgChang(val) {
                this.searchRequery.url = val
            },

            // 默认请求参数
            requestDefault() {
                services.appTypeAll()
                    .then(res => {
                        this.listAll.type_list = Object.keys(res.apptype_data).map(item => ({ value: item, label: res.apptype_data[item] }))
                    })

                services.imgList()
                    .then(res => this.listAll.img_list = res)
                    .catch((err) => this.$message.error(err.message))
            },

            // 加载联动菜单
            lazyLoad (node, resolve) {
                const { level } = node;
                if(!level){
                    services.treeLevel1()
                        .then(res => {
                            let nodes = res.list.map(item=>({
                                value: item.id,
                                label: item.name,
                                leaf: item.is_folder ? false: true
                            }))
                            nodes = nodes.filter(item => !item.leaf)
                            resolve(nodes)
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => this.loading = false)
                }else{
                    services.treeChildren({ id: node.value })
                        .then(res => {
                            let nodes = res.list.map(item=>({
                                value: item.id,
                                label: item.name,
                                leaf: item.is_folder ? false: true
                            }))
                            nodes = nodes.filter(item => !item.leaf)
                            resolve(nodes)
                        })
                        .catch(err => this.$message.error(err.message))
                        .finally(() => this.loading = false)
                }
            },

            // 获取详情
            getDetail() {
                services.nodeInfo({ appId: this.appnodeId })
                    .then(res => {
                        this.form = {
                            ...res,
                            rank: res.rank,
                            apptype: +res.apptype,
                            superviser: res.superviser.map(item => item.name),
                            invokedApp:res.invoked_app.length!==0?res.invoked_app.map(item=>item.id):[],
                            devuser: res.devuser.map(item => item.name),
                            qauser: res.qauser.map(item => item.name),
                            pmuser: res.pmuser.map(item => item.name),
                            projectusers: res.projectusers.map(item => item.name),
                            maintainusers: res.maintainusers.map(item => item.name),
                            mails: res.mail.map(item => item.mail)
                        }
                        //编辑时存一下上次的env
                        this.oldEnv=res.env
                        this.$refs.getDefaultValue.$el.children[0].children[0].value = this.form.parent_cname
                        let params = this.type_list.filter(item => this.form.apptype === item.default)[0]
                        params = {
                            ...params,
                            env: this.form.params,
                            server: this.form.server
                        }
                        this.$store.commit("setParamEnv", params)
                        this.userList = {
                            superviser: res.superviser,
                            devuser: res.devuser,
                            qauser: res.qauser,
                            pmuser: res.pmuser,
                            projectusers: res.projectusers,
                            maintainusers: res.maintainusers
                        }
                        this.appList=res.invoked_app
                    })
            },

            // 获取params
            getParams() {
                return {
                    ...this.form,
                    id: this.appnodeId,
                    // img_url: this.searchRequery.url,
                    parent_id: typeof(this.form.parent_id) === 'object' ? this.form.parent_id[this.form.parent_id.length - 1] : this.form.parent_id,
                    superviser: this.type === "add" ? this.form.superviser.map(item => JSON.parse(item)) : this.setUser('superviser'),
                    projectusers: this.type === "add" ? this.form.projectusers.map(item => JSON.parse(item)) : this.setUser('projectusers'),
                    maintainusers: this.type === "add" ? this.form.maintainusers.map(item => JSON.parse(item)) : this.setUser('maintainusers'),
                    devuser: this.type === "add" ? this.form.devuser.map(item => JSON.parse(item)) : this.setUser('devuser'),
                    qauser: this.type === "add" ? this.form.qauser.map(item => JSON.parse(item)) : this.setUser('qauser'),
                    pmuser: this.type === "add" ? this.form.pmuser.map(item => JSON.parse(item)) : this.setUser('pmuser'),
                    params: this.useParams.env.map(item => ({envId: item.envId, param: item.param})),
                    server: this.useParams.server,
                    invokedApp:this.type==='add'?this.form.invokedApp:this.form.invokedApp.map(item => item.toString()),
                    userTagList: this.userTagList,
                    paramsTag: this.paramsTag ? this.paramsTag : this.useParams.paramsTag,
                    serviceTag: this.useParams.serviceTag
                }
            },

            // 设置人员
            setUser(title) {
                let arr = []
                this.form[title].forEach(item => {
                    if (item.length > 20) {
                        arr.push(JSON.parse(item))
                    } else {
                        let filterArr = this.userList[title].filter(i => i.name === item)
                        if (filterArr.length) arr.push(filterArr[0])
                    }
                })
                return arr;
            },
            //设置应用
            setApp(){
                let arr=[]
                this.form.invokedApp.forEach(item=>{
                    let filterArr=this.listAll.app_list.filter(i=>i.id==item)
                    if (filterArr.length) arr.push(filterArr[0])
                })
                return arr
            },

            // 提交按钮
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let params = this.getParams()
                        if (this.type === 'edit') {
                            if (this.isDeployed){
                                this.request('updateNode', params, '编辑成功')
                            } else{
                                this.$message.error('环境有变动，请点击部署信息按钮进行查看或编辑')
                            }

                        } else {
                            if(this.isDeployed){
                                this.request('addNode', params, '创建成功')
                            }else{
                                this.$message.error('请点击部署信息按钮进行查看或编辑')
                            }

                        }
                    }
                    else return
                })
            },

            // 发送请求
            request(request, params, info) {
                // console.log(params, 'params')
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                services[request](params)
                    .then(response => this.$message.success(info))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close()
                        this.$modal.close()
                        this.callback({id: this.appnodeId})
                        this.$nextTick()
                    })
            },

            // 取消按钮
            onCancel() {
                this.$modal.close();
            },

            // 搜索人员
            remoteMethodUser(query, title) {
                this.listAll[title] = []
                if (query !== '') {
                    this.loading = true
                    services.filterUser(query)
                        .then(res => {
                            let list = []
                            for (let item in res.user_data) {
                                list.push({
                                    value: JSON.stringify(res.user_data[item]),
                                    label: res.user_data[item] && res.user_data[item].name + '(' + item + ')'
                                })
                            }
                            this.loading = false
                            this.listAll[title] = list
                            // console.log(this.listAll[title], 'ssssssssss')
                        })
                        .catch(err => this.$message.error(err.message))
                } else {
                    this.listAll[title] = []
                }
            },
            // 搜索应用
            remoteMethodApp(query) {
                // console.log(query);
                if (query !== '') {
                    this.loading = true
                    let params={
                        pageIndex:1,
                        pageSize:10000,
                        keyword:query
                    }
                    services.getAppList(params)
                        .then(res => {
                            let list = []
                            for (let item in res.app_list) {
                                list.push({
                                    id: res.app_list[item].id.toString(),
                                    name: res.app_list[item] && res.app_list[item].name
                                })
                            }
                            this.loading = false
                            this.listAll.app_list = list
                        })
                        .catch(err => this.$message.error(err.message))
                    // this.listAll.app_list.forEach(item=>{
                    //     if (item.name.indexOf(`${query}`)>-1) {
                    //         console.log('bingo');
                    //     }
                    // })
                    // this.listAll.app_list=this.listAll.app_list.filter(item=>{
                    //     return item.name.indexOf(`${query}`)>-1
                    // })
                } else {
                    this.listAll.app_list = []
                }
            },

            // 人员被改变时
            changeUser(title) {
                this.userTagList.push(title)
            },

            // 搜索Git 地址
            remoteMethodGit(query) {
                if (query !== '') {
                    this.loading = true
                    let list = []
                    services.gitSearch(query).then(response => {
                        this.loading = false
                        this.listAll.Git_list = response
                    })
                } else {
                    this.listAll.Git_list = []
                }
            },

            handleClose(tag) {
                this.form.mails.splice(this.form.mails.indexOf(tag), 1);
                this.userTagList.push('mails')
            },

            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },

            handleInputConfirm() {
                let inputValue = this.inputValue;
                this.userTagList.push('mails')
                if (inputValue) {
                    let re=/^\w+@[a-z0-9]+\.[a-z]{2,4}$/;
                    if (re.test(inputValue)) {
                        this.form.mails.push(inputValue);
                    } else {
                        this.$message.error('请输入正确的邮箱')
                    }
                }
                this.inputVisible = false;
                this.inputValue = '';
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },
        }
    }
</script>

<style lang='scss' scoped>
    .file {
        position: relative;
        display: inline-block;
        background: #67c23a;
        border: 1px solid #67c23a;
        border-radius: 4px;
        padding: 4px 12px;
        overflow: hidden;
        color: #fff;
        text-decoration: none;
        text-indent: 0;
        line-height: 16px;
        vertical-align: middle;
        input {
            position: absolute;
            right: 0;
            top: 0;
            opacity: 0;
        }
    }
    img {
        width: 20px;
        height: 20px;
        margin:0 10px;
        vertical-align: middle;
    }
    .el-tag + .el-tag {
        margin-left: 10px;
    }
    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .mailBtn {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        margin-top: 5px;
    }
</style>

